import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import {getLanguageFromURL} from "../utils/common";

const directLinkLanguage = getLanguageFromURL() || 'ru';
const getLanguage = (directLinkLanguage: string) => {
    switch (directLinkLanguage) {
        case 'en':
            return 'en';
        case 'am':
            return 'am';
        case 'ru':
            return 'ru';
        default:
            return 'ru';
    }
}

i18n
    .use(Backend)
    .use(initReactI18next)
    .init({
        fallbackLng: getLanguage(directLinkLanguage),
        debug: process.env.NODE_ENV === 'development',
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        backend: {
            loadPath: '/locales/{{lng}}/{{ns}}.json',
        },
    });

export default i18n;
